<template>
  <div id="summary-content" class="summary-content">
    <div
      v-if="isLoading"
      ref="loader-container"
      class="summary-content__loader"
      :style="loaderStyle"
    >
      <img src="@/assets/images/mceasy-loader.gif" width="100" />
    </div>
    <iframe
      v-show="!isLoading"
      :id="id"
      v-resize="{ log: true }"
      class="summary-content__frame"
      :style="frameStyle"
      :src="link"
      @load="isLoading = false"
    />
  </div>
</template>

<script>
import iframeResize from 'iframe-resizer/js/iframeResizer'

export default {
  directives: {
    resize: {
      bind: function (el, { value = {} }) {
        el.addEventListener('load', () => iframeResize(value, el))
      },
      unbind: function (el) {
        el.iFrameResizer.removeListeners()
      },
    },
  },
  props: {
    id: {
      type: String,
    },
    link: {
      type: String,
    },
  },
  data() {
    return {
      loaderStyle: {},
      frameStyle: {
        width: '100%',
      },
      isLoading: true,
    }
  },
  mounted() {
    const loader = this.$refs['loader-container']
    this.$set(this.loaderStyle, 'height', `${window.innerHeight - (loader.offsetTop + 150)}px`)
  },
}
</script>

<style lang="scss">
.summary-content {
  &__loader {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
